import React, { useState, useRef } from "react";
import { Modal, Tabs, Tab, Form, Row, Col, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import ReactQuill from "react-quill";
import "react-datepicker/dist/react-datepicker.css";
import "react-quill/dist/quill.snow.css";
import { FiCalendar } from "react-icons/fi";

export default function AddProjectModal({ showProject, setShowProject }) {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [logo, setLogo] = useState(null);

  const [description, setDescription] = useState("");

  const [showImageModal, setShowImageModal] = useState(false);

  const [imageUrl, setImageUrl] = useState("");

  const fileInputRef = useRef(null);

  const quillRef = useRef();

  const uploadLogo = (e) => {
    setLogo(URL.createObjectURL(e.target.files[0]));
  };

  // open file browser
  const handleChooseFile = () => {
    fileInputRef.current.click();
  };

  // when file selected
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        insertImage(reader.result);
      };

      reader.readAsDataURL(file);
    }
  };

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate size (4MB)
    if (file.size > 4 * 1024 * 1024) {
      alert("Image should be below 4 MB");
      return;
    }

    const imageUrl = URL.createObjectURL(file);
    setLogo(imageUrl);
  };

  const handleCancel = () => {
    setLogo(null);
  };
  // insert image in editor
  const insertImage = (url) => {
    const editor = quillRef.current.getEditor();

    const range = editor.getSelection();

    editor.insertEmbed(range.index, "image", url);

    setShowImageModal(false);
  };

  // insert image url
  const insertImageFromUrl = () => {
    if (imageUrl) {
      insertImage(imageUrl);

      setImageUrl("");
    }
  };

  // quill toolbar config
  const modules = {
    toolbar: {
      container: [
        [{ size: [] }],

        ["bold", "italic", "underline"],

        ["link", "image"],
      ],

      handlers: {
        image: () => {
          setShowImageModal(true);
        },
      },
    },
  };

   // States
  const [teamMembers, setTeamMembers] = useState([
    "Jerald",
    "Andrew",
    "Philip",
    "Davis",
  ]);
  const [teamLeader, setTeamLeader] = useState([
    "Hendry",
    "James",
  ]);
  const [projectManager, setProjectManager] = useState([
    "Dwight",
  ]);
  const [tags, setTags] = useState([
    "Collab",
    "Promotion",
    "Rated",
  ]);

  const [inputs, setInputs] = useState({
    teamMembers: "",
    teamLeader: "",
    projectManager: "",
    tags: "",
  });

  // Handle typing
  const handleChange = (field, value) => {
    setInputs({ ...inputs, [field]: value });
  };

  // Add tag
  const handleKeyDown = (e, field, list, setList) => {
    if (e.key === "Enter" && inputs[field].trim() !== "") {
      e.preventDefault();

      if (!list.includes(inputs[field].trim())) {
        setList([...list, inputs[field].trim()]);
      }

      setInputs({ ...inputs, [field]: "" });
    }
  };

  // Remove tag
  const removeTag = (index, list, setList) => {
    setList(list.filter((_, i) => i !== index));
  };

  // Common style
  const boxStyle = {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "6px",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "8px",
    minHeight: "45px",
  };

  const tagStyle = {
    background: "#e5e7eb",
    padding: "4px 8px",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "13px",
  };

  const inputStyle = {
    border: "none",
    outline: "none",
    flex: 1,
    minWidth: "120px",
  };
  return (
    <>
      <Modal className="mt-2"
        show={showProject}
        onHide={() => setShowProject(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Add Project
            <span className="text-muted ms-2 fs-6">Project ID : PRO-0004</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Tabs defaultActiveKey="basic">
            {/* BASIC INFO TAB */}

            <Tab eventKey="basic" title="Basic Information">
              <div className="p-3">
                {/* Logo Upload */}

            <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: "10px",
        padding: "16px",
        background: "#f9fafb",
      }}
    >
      <Row
        style={{
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        {/* Left Image */}
        <Col
          xs={12}
          md={3}
          style={{
            textAlign: "center",
            marginBottom: "10px",
          }}
        >
          <div
            style={{
              width: "80px",
              height: "80px",
              border: "1px dashed #d1d5db",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "auto",
              overflow: "hidden",
              background: "#fff",
            }}
          >
            <img
              src={
                  "/assets/img/icons/upload-icon.svg"
              }
              alt="logo"
              style={{
                width: logo ? "100%" : "35px",
                height: logo ? "100%" : "35px",
                objectFit: "cover",
              }}
            />
          </div>

          {/* Hidden Input */}
          <input
            type="file"
            accept="image/*"
            onChange={handleUpload}
            id="uploadFile"
            style={{ display: "none" }}
          />

        </Col>

        {/* Right Content */}
        <Col xs={12} md={9}>
          <h6
            style={{
              fontWeight: "600",
              marginBottom: "4px",
            }}
          >
            Upload Project Logo
          </h6>

          <p
            style={{
              color: "#6b7280",
              fontSize: "14px",
              marginBottom: "6px",
            }}
          >
            Image should be below 4 mb
          </p>
  <div className="d-flex align-item-center g-3">
             {/* Upload Button */}
          <label
            htmlFor="uploadFile"
            style={{
              display: "inline-block",
              marginTop: "10px",
              padding: "6px 16px",
              background: "#f97316",
              color: "#fff",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Upload
          </label>
          {logo ? (
            <Button className=" ms-2  border border-1"
              variant="light"
              onClick={handleCancel}
              style={{
                borderRadius: "6px",
                padding: "0px 10px",
              }}
            >
              Cancel
            </Button>
          ):(    <Button className=" ms-2 border border-1"
              variant="light"
              onClick={handleCancel}
              style={{
                borderRadius: "6px",
                padding: "0px 10px",
              }}
            >
              Cancel
            </Button>)}
  </div>
 
        </Col>
      </Row>
    </div>

                <Form.Group className="mb-3">
                  <Form.Label>Project Name</Form.Label>

                  <Form.Control />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Client</Form.Label>

                  <Form.Select>
                    <option>Select</option>
                  </Form.Select>
                </Form.Group>

                <Row>
                  <Col md={6}>
                    <Form.Label>Start Date</Form.Label>

                    <div className="position-relative">
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        className="form-control"
                      />

                      <FiCalendar className="calendar-icon" />
                    </div>
                  </Col>

                  <Col md={6}>
                    <Form.Label>End Date</Form.Label>

                    <div className="position-relative">
                      <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        className="form-control"
                      />

                      <FiCalendar className="calendar-icon" />
                    </div>
                  </Col>
                </Row>
<Row className="mt-3">

{/* Priority */}

<Col md={4}>
<Form.Group>

<Form.Label>Priority</Form.Label>

<Form.Select>

<option>Select</option>
<option>Low</option>
<option>Medium</option>
<option>High</option>

</Form.Select>

</Form.Group>
</Col>


{/* Project Value */}

<Col md={4}>

<Form.Group>

<Form.Label>Project Value</Form.Label>

<div className="input-group">

<span className="input-group-text">$</span>

<Form.Control type="text"/>

</div>

</Form.Group>

</Col>


{/* Price Type */}

<Col md={4}>

<Form.Group>

<Form.Label>Price Type</Form.Label>

<Form.Control type="text"/>

</Form.Group>

</Col>

</Row>
                {/* Description */}

                <Form.Group className="mt-3">
                  <Form.Label>Description</Form.Label>

                  <ReactQuill
                    ref={quillRef}
                    value={description}
                    onChange={setDescription}
                    modules={modules}
                  />
                </Form.Group>

                <Form.Group className="mt-3">
                  <Form.Label>Upload Files</Form.Label>

                  <Form.Control type="file" />
                </Form.Group>
              </div>
            </Tab>

            {/* MEMBERS TAB */}

             <Tab eventKey="members" title="Members">
      <div style={{ padding: "16px" }}>
        {/* Team Members */}
        <Form.Group style={{ marginBottom: "16px" }}>
          <Form.Label>Team Members</Form.Label>
          <div style={boxStyle}>
            {teamMembers.map((item, i) => (
              <span key={i} style={tagStyle}>
                {item}
                <button
                  onClick={() =>
                    removeTag(i, teamMembers, setTeamMembers)
                  }
                  style={{ border: "none", background: "none" }}
                >
                  x
                </button>
              </span>
            ))}
            <input
              placeholder="Add new"
              value={inputs.teamMembers}
              onChange={(e) =>
                handleChange("teamMembers", e.target.value)
              }
              onKeyDown={(e) =>
                handleKeyDown(
                  e,
                  "teamMembers",
                  teamMembers,
                  setTeamMembers
                )
              }
              style={inputStyle}
            />
          </div>
        </Form.Group>

        {/* Team Leader */}
        <Form.Group style={{ marginBottom: "16px" }}>
          <Form.Label>Team Leader</Form.Label>
          <div style={boxStyle}>
            {teamLeader.map((item, i) => (
              <span key={i} style={tagStyle}>
                {item}
                <button
                  onClick={() =>
                    removeTag(i, teamLeader, setTeamLeader)
                  }
                  style={{ border: "none", background: "none" }}
                >
                  x
                </button>
              </span>
            ))}
            <input
              placeholder="Add new"
              value={inputs.teamLeader}
              onChange={(e) =>
                handleChange("teamLeader", e.target.value)
              }
              onKeyDown={(e) =>
                handleKeyDown(
                  e,
                  "teamLeader",
                  teamLeader,
                  setTeamLeader
                )
              }
              style={inputStyle}
            />
          </div>
        </Form.Group>

        {/* Project Manager */}
        <Form.Group style={{ marginBottom: "16px" }}>
          <Form.Label>Project Manager</Form.Label>
          <div style={boxStyle}>
            {projectManager.map((item, i) => (
              <span key={i} style={tagStyle}>
                {item}
                <button
                  onClick={() =>
                    removeTag(i, projectManager, setProjectManager)
                  }
                  style={{ border: "none", background: "none" }}
                >
                  x
                </button>
              </span>
            ))}
            <input
              placeholder="Add new"
              value={inputs.projectManager}
              onChange={(e) =>
                handleChange("projectManager", e.target.value)
              }
              onKeyDown={(e) =>
                handleKeyDown(
                  e,
                  "projectManager",
                  projectManager,
                  setProjectManager
                )
              }
              style={inputStyle}
            />
          </div>
        </Form.Group>

        {/* Tags */}
        <Form.Group style={{ marginBottom: "16px" }}>
          <Form.Label>Tags</Form.Label>
          <div style={boxStyle}>
            {tags.map((item, i) => (
              <span key={i} style={tagStyle}>
                {item}
                <button
                  onClick={() => removeTag(i, tags, setTags)}
                  style={{ border: "none", background: "none" }}
                >
                  x
                </button>
              </span>
            ))}
            <input
              placeholder="Add new"
              value={inputs.tags}
              onChange={(e) =>
                handleChange("tags", e.target.value)
              }
              onKeyDown={(e) =>
                handleKeyDown(e, "tags", tags, setTags)
              }
              style={inputStyle}
            />
          </div>
        </Form.Group>

        {/* Status */}
        <Form.Group>
          <Form.Label>Status</Form.Label>
          <Form.Select
            style={{
              height: "45px",
              borderRadius: "8px",
            }}
          >
            <option>Select</option>
            <option>Active</option>
            <option>Inactive</option>
          </Form.Select>
        </Form.Group>
      </div>
    </Tab>
          </Tabs>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="light">Cancel</Button>

          <Button  className="border border-1" style={{ background: "#ff6b1a",}}>Save</Button>
        </Modal.Footer>
      </Modal>

      {/* INSERT IMAGE MODAL */}

      <Modal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Insert Image</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Select from files</Form.Label>

            <Form.Control
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Image URL</Form.Label>

            <Form.Control
              value={imageUrl}
              onChange={(e) => setImageUrl(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button style={{ background: "#ff6b1a",}} onClick={insertImageFromUrl}>
            Insert Image
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
